import { UserRole } from "..";

export enum ConflictsAction {
    ViewSettingsPage,
    BypassRowLevelSecurity, //Skip checking RLS for this user.  ASSIGN WITH EXTREME CAUTION
    CanRefineSearches,
    ChangeStatusOnCompleteSearches,
    ChangeHitStatusOnOthersSearches, //noone is allowed to do this atm, but I chucked it in the list and check it in code for completions sake
    ChangeHitStatusOnOwnSearches,
    CreateSearchVersion,
    CreateDraftSearch,
    EditSubmittedSearch,
    PerformSearch, //Not fully consumed
    ReassignSearchesAssignedToOthers,
    ReassignSearchesAssignedToSelf,
    ReassignHitsAssignedToOthers,
    ReassignHitsAssignedToSelf,
    SubmitSearch,
    UpdateHitResultGridConfiguration, //Can customize the Hit Result Grid Configuration
    ViewAndEditFirmOptions,
    ViewAndPerformQuickSearches,
    ViewAndUpdateEntityFlyoutConfiguration, //Can customize the Entity flyout
    ViewAndUpdateEntityRelationshipConfiguration, //Can customize the Entity Relationship Configuration
    ViewAndUpdateSynonymMaps,
    ViewAnyEntityData, //Can query any entity via the EntityStore'
    ViewHitResultGridConfiguration, //Can retrieve the Hit Result Grid Configuration - needed for viewing the Hit Result grid
    ViewIngestionPipelineStatus,
    ViewIngestionSanctionStatus,
    ViewOthersDraftSearches, //this one should never be given to anybody, it's just here for consistency with error reporting
    ViewOthersSearchesAndAllHits,
    ViewOwnSearchesAndAllHits,
    ViewAndUpdateRlsColumnVisibility, //Can choose fields to un-redact when an entity is secured with row level security
    /**DONT PUT THESE TWO ON ANYTHING OTHER THAN ApiAdmin PLEASE */
    ViewAndCreateApiKeys,
    RevokeApiKeys,
    ViewSearchesAndHitsSharedToUser,
    ViewAndUpdateReviewerOptions,
    ChangeHitStatusOnHitsSharedToUser,
    DeleteEntityType,
    SaveSanctionsList,
    CreateQuickSearch
    /**------------------------------------------------------ */
}

type UserRoleKey = keyof typeof UserRole;

export const UserPermissionsForRole: Record<UserRoleKey, ConflictsAction[]> = {
    ["Conflicts"]: [
        ConflictsAction.ViewOwnSearchesAndAllHits,
        ConflictsAction.ViewOthersSearchesAndAllHits,
        ConflictsAction.ReassignSearchesAssignedToSelf,
        ConflictsAction.ReassignSearchesAssignedToOthers,
        ConflictsAction.ReassignHitsAssignedToSelf,
        ConflictsAction.ReassignHitsAssignedToOthers,
        ConflictsAction.ChangeHitStatusOnOwnSearches,
        ConflictsAction.ChangeStatusOnCompleteSearches,
        ConflictsAction.SubmitSearch,
        ConflictsAction.EditSubmittedSearch,
        ConflictsAction.PerformSearch,
        ConflictsAction.CreateSearchVersion,
        ConflictsAction.ViewAnyEntityData,
        ConflictsAction.ViewHitResultGridConfiguration,
        ConflictsAction.ViewAndPerformQuickSearches,
        ConflictsAction.CreateQuickSearch,
        ConflictsAction.CreateDraftSearch
    ],
    ["Standard"]: [
        ConflictsAction.ViewOwnSearchesAndAllHits,
        ConflictsAction.ReassignSearchesAssignedToSelf,
        ConflictsAction.ReassignHitsAssignedToSelf,
        ConflictsAction.ChangeHitStatusOnOwnSearches,
        ConflictsAction.SubmitSearch,
        ConflictsAction.EditSubmittedSearch,
        ConflictsAction.ViewAnyEntityData,
        ConflictsAction.ViewHitResultGridConfiguration,
        ConflictsAction.CreateQuickSearch,
        ConflictsAction.CreateDraftSearch
    ],
    ["Admin"]: [
        ConflictsAction.ViewSettingsPage,
        ConflictsAction.ViewAndUpdateSynonymMaps,
        ConflictsAction.ViewAndUpdateEntityFlyoutConfiguration,
        ConflictsAction.ViewAndUpdateEntityRelationshipConfiguration,
        ConflictsAction.ViewHitResultGridConfiguration,
        ConflictsAction.UpdateHitResultGridConfiguration,
        ConflictsAction.ViewIngestionPipelineStatus,
        ConflictsAction.ViewIngestionSanctionStatus,
        ConflictsAction.ViewAndEditFirmOptions,
        ConflictsAction.ViewAndUpdateRlsColumnVisibility,
        ConflictsAction.ViewAndUpdateReviewerOptions,
        ConflictsAction.DeleteEntityType,
        ConflictsAction.SaveSanctionsList
    ],
    ["ApiAdmin"]: [ConflictsAction.ViewAndCreateApiKeys, ConflictsAction.RevokeApiKeys, ConflictsAction.ViewSettingsPage],
    ["SecurityPlanExempt"]: [ConflictsAction.BypassRowLevelSecurity],
    ["Reviewer"]: [
        ConflictsAction.ViewHitResultGridConfiguration,
        ConflictsAction.ViewSearchesAndHitsSharedToUser,
        ConflictsAction.ChangeHitStatusOnHitsSharedToUser,
        ConflictsAction.ViewAnyEntityData
    ],
    ["None"]: []
};
